import React, { createContext, useContext, useState, useEffect } from 'react';
import modelService from '../services/modelService';

const ModelContext = createContext();

export function useModels() {
  const context = useContext(ModelContext);
  if (!context) {
    throw new Error('useModels must be used within a ModelProvider');
  }
  return context;
}

export function ModelProvider({ children }) {
  const [models, setModels] = useState({
    chat: [],
    image: [],
    video: [],
    music: [],
    code: [],
    research: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadModels = async () => {
    setLoading(true);
    setError(null);
    try {
      const [chat, image, video, music, code, research] = await Promise.all([
        modelService.getModelsByFunction('chat'),
        modelService.getModelsByFunction('image'),
        modelService.getModelsByFunction('video'),
        modelService.getModelsByFunction('music'),
        modelService.getModelsByFunction('code'),
        modelService.getModelsByFunction('research')
      ]);

      setModels({ chat, image, video, music, code, research });
    } catch (err) {
      console.error('Failed to load models:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refreshModels = async () => {
    await modelService.refreshModels();
    await loadModels();
  };

  useEffect(() => {
    loadModels();
  }, []);

  return (
    <ModelContext.Provider value={{ models, loading, error, refreshModels }}>
      {children}
    </ModelContext.Provider>
  );
}
